module.exports = __webpack_public_path__ + "static/media/home-graphic-element.26a243f2.svg";